//screen/NewTransactionScreen.js
import React from "react";
import {
    Box,
    Typography,
    List,
    ListItem,
    ListItemText,
    Divider,
    Button,
    CssBaseline,
    Snackbar,
    Alert,
} from "@mui/material";
import { useNavigate, Routes, Route, useLocation } from "react-router-dom";
import MoneyInput from "../component/MoneyInput";
import ProjectInput from "../component/ProjectInput";
import DateInput from "../component/DateInput";
import CommentInput from "../component/CommentInput";
import { PlaylistAddSharp } from "@mui/icons-material";
import useTransactionForm from "../hooks/useTransactionForm";
import DescriptionInput from "../component/DescriptionInput";
import TypeInput from "../component/TypeInput";
import ReceiptInput from "../component/ReceiptInput";
import ExpenseCodeInput from "../component/ExpenseCodeInput";

const NewTransactionScreen = () => {
    const { transaction, updateField, submit, showNotification, setShowNotification, loading } = useTransactionForm();
    const navigate = useNavigate();
    const location = useLocation();

    // Проверяем, находится ли пользователь на вложенном маршруте
    const isSubRoute = location.pathname !== "/spa/transaction";

    const itemContent = (label, value, defaultValue = "Выбрать...") => {
        if (!value) {
            value = defaultValue;
        } else if (Array.isArray(value)) {
            value = value.map((v) => v.name).join(", ");
        } else if (label === "Дата") {
            value = new Date(value).toLocaleDateString();
        } else if (typeof value === "object" && value.name) {
            value = value.name;
        }

        return (
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography fontWeight="bold">{label}</Typography>
                <Typography sx={{ color: "gray", fontSize: "0.875rem" }}>{value}</Typography>
            </Box>
        );
    };

    return (
        <Box>
            <CssBaseline />
            <Routes>
                <Route
                    path="project"
                    element={<ProjectInput value={transaction.project} onChange={(value) => updateField("project", value)} />} />
                <Route
                    path="date"
                    element={<DateInput value={transaction.datetime} onChange={(value) => updateField("datetime", value)} />} />
                <Route
                    path="comment"
                    element={<CommentInput value={transaction.comment} onChange={(value) => updateField("comment", value)} />} />
                <Route
                    path="description"
                    element={<DescriptionInput value={transaction.description} onChange={(value) => updateField("description", value)} />} />
                <Route
                    path="type"
                    element={<TypeInput value={transaction.type} onChange={(value) => updateField("type", value)} />} />
                <Route
                    path="receipt"
                    element={<ReceiptInput value={transaction.receipt} onChange={(value) => updateField("receipt", value)} />} />
                <Route
                    path="expenseCode"
                    element={<ExpenseCodeInput value={transaction.expenseCode} onChange={(value) => updateField("expenseCode", value)} />} />
            </Routes>

            {/* Основной контент */}
            {!isSubRoute && (
                <Box sx={{ mx: "auto", p: 2 }}>
                    <MoneyInput value={transaction.sum} onChange={(value) => updateField("sum", value)} />
                    <List disablePadding>
                        <ListItem button onClick={() => navigate("project")}>
                            <ListItemText primary={itemContent("Проект", transaction.project)} />
                        </ListItem>
                        <Divider />
                        <ListItem button onClick={() => navigate("date")}>
                            <ListItemText primary={itemContent("Дата", transaction.datetime)} />
                        </ListItem>
                        <Divider />
                        <ListItem button onClick={() => navigate("comment")}>
                            <ListItemText primary={itemContent("Комментарий", transaction.comment)} />
                        </ListItem>
                        <Divider />
                        <ListItem button onClick={() => navigate("expenseCode")}>
                            <ListItemText primary={itemContent("Код", transaction.expenseCode?.display)} />
                        </ListItem>
                        <Divider />
                        <ListItem button onClick={() => navigate("description")}>
                            <ListItemText primary={itemContent("Описание", transaction.description)} />
                        </ListItem>
                        <Divider />
                        <ListItem button onClick={() => navigate("type")}>
                            <ListItemText primary={itemContent("Тип", transaction.type?.display)} />
                        </ListItem>
                        <Divider />
                        <ListItem button onClick={() => navigate("receipt")}>
                            <ListItemText
                                primary={itemContent("Фото чека", transaction.receipt?.text || transaction.receipt?.file)}
                            />
                        </ListItem>
                        <Divider />
                    </List>
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 4 }}>
                        <Button
                            variant="contained"
                            color="success"
                            endIcon={<PlaylistAddSharp />}
                            onClick={() => submit().then(() => navigate("/spa/journal"))}
                            disabled={loading}
                        >
                            Добавить
                        </Button>
                    </Box>
                    <Snackbar
                        open={showNotification}
                        autoHideDuration={3000}
                        onClose={() => setShowNotification(false)}
                    >
                        <Alert onClose={() => setShowNotification(false)} severity="success">
                            Транзакция добавлена!
                        </Alert>
                    </Snackbar>
                </Box>
            )}
        </Box>
    );
};

export default NewTransactionScreen;
